import React from "react";
import { Tabs, BIG5_ICONS } from "@/components/vb";
import type { Big5Category } from "@/types/vb";
import type { VerdictModel } from "./verdictModel";

/** Big-5 category tab bar (VB-F1) — the shared Tabs primitive in its segmented
 *  (pill-track) look, controlling the shared `vb-qcards-panel`. The count is the
 *  number of questions the buyer has in that category. */
export function Big5Tabs({
  categories,
  active,
  onSelect,
}: {
  categories: VerdictModel["categories"];
  active: Big5Category;
  onSelect: (c: Big5Category) => void;
}) {
  return (
    <Tabs
      variant="segmented"
      ariaLabel="Big-5 question categories"
      idBase="vb-tab"
      panelId="vb-qcards-panel"
      value={active}
      onChange={(v) => onSelect(v as Big5Category)}
      items={categories.map((c) => {
        const Icon = BIG5_ICONS[c.category];
        return {
          value: c.category,
          label: c.label,
          icon: <Icon size={15} />,
          count: c.count,
        };
      })}
    />
  );
}

export default Big5Tabs;
